// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CZRxD","open":"styles_open__ir8Nv","item":"styles_item__0awYO","link":"styles_link__nzJVL"};